import React, { useState, useEffect } from "react";
import { TezosToolkit } from "@taquito/taquito";
import { BeaconWallet } from "@taquito/beacon-wallet";
import axios from "axios";

const Tezos = new TezosToolkit("https://mainnet.smartpy.io");
const wallet = new BeaconWallet({ name: "Temple Wallet Swap" });
Tezos.setWalletProvider(wallet);

const SwapPage = () => {
  const [walletAddress, setWalletAddress] = useState("");
  const [oXTZAmount, setOXTZAmount] = useState("");
  const [XTZAmount, setXTZAmount] = useState("0.000000");
  const [exchangeRate, setExchangeRate] = useState(1);
  const [isSwapping, setIsSwapping] = useState(false);
  const [error, setError] = useState("");
  const minSwapAmount = 0.150001;

  useEffect(() => {
    const storedAddress = localStorage.getItem("walletAddress");
    if (storedAddress) {
      setWalletAddress(storedAddress);
      fetchExchangeRate(storedAddress);
    }
  }, []);

  const fetchExchangeRate = async () => {
    try {
      const response = await axios.get("https://api.example.com/exchange-rate"); // Replace with real API
      setExchangeRate(response.data.rate || 1);
    } catch (err) {
      console.error("Error fetching exchange rate:", err);
    }
  };

  const handleSwap = async () => {
    setError("");
    if (!oXTZAmount || parseFloat(oXTZAmount) <= 0) {
      setError("Please enter a valid amount.");
      return;
    }
    if (parseFloat(oXTZAmount) < minSwapAmount) {
      setError(`Minimum swap amount is ${minSwapAmount} oXTZ.`);
      return;
    }
    setIsSwapping(true);
    try {
      console.log(`Swapping ${oXTZAmount} oXTZ for ꜩ`);
      alert(`Swap successful! You received ${XTZAmount} ꜩ`);
    } catch (err) {
      console.error("Swap error:", err);
    }
    setIsSwapping(false);
  };

  useEffect(() => {
    setXTZAmount((parseFloat(oXTZAmount) * exchangeRate).toFixed(6));
  }, [oXTZAmount, exchangeRate]);

  return (
    <div className="min-h-screen flex justify-center items-center bg-gray-100 p-28">
      <div className="bg-white shadow-lg rounded-lg p-6 w-[500px] text-center border border-gray-300">
        <h2 className="text-xl font-semibold mb-4">Swap oXTZ for ꜩ</h2>
        <p className="text-sm text-gray-500">
          Wallet: {walletAddress || "Not Connected"}
        </p>
        <div className="border p-4 rounded-lg mt-4">
          <div className="flex justify-between items-center p-2 border rounded mb-2">
            <img
              src="/img/wallet/wXTZ.svg"
              alt="oXTZ"
              className="h-6 w-6 mr-2"
            />
            <input
              type="number"
              className="w-full p-2 border-none"
              value={oXTZAmount}
              onChange={(e) => setOXTZAmount(e.target.value)}
              placeholder="0"
            />
            <span className="text-sm font-semibold">oXTZ</span>
          </div>
          {parseFloat(oXTZAmount) < minSwapAmount && oXTZAmount !== "" && (
            <p className="text-red-500 text-xs text-left ml-2">
              Min is {minSwapAmount}
            </p>
          )}
          <p className="text-gray-700 my-2">⇅</p>
          <div className="flex justify-between items-center p-2 border rounded mb-2">
            <img src="/img/wallet/ꜩ.svg" alt="ꜩ" className="h-6 w-6 mr-2" />
            <input
              type="text"
              className="w-full p-2 border-none bg-gray-100 cursor-not-allowed"
              value={XTZAmount}
              disabled
            />
            <span className="text-sm font-semibold">ꜩ</span>
          </div>
        </div>
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        <button
          className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full flex justify-center items-center"
          onClick={handleSwap}
          disabled={isSwapping}
        >
          {isSwapping ? (
            <span className="flex items-center">
              <svg className="animate-spin h-5 w-5 mr-2" viewBox="0 0 24 24">
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
              Swapping...
            </span>
          ) : (
            "Swap"
          )}
        </button>
      </div>
    </div>
  );
};

export default SwapPage;
